import { createUseStyles } from "react-jss";
import { COLORS } from "./defaults";

export const styleAlertBox = createUseStyles({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Fondo oscuro semi-transparente
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999, // Muy alto para asegurarse de que esté encima de todo
  },
  alertBox: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '10px',
    // maxWidth: '400px',
    width: '80%',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    textAlign: 'center', // Centrar contenido
  },
  icon: {
    fontSize: '50px', // Tamaño grande para el icono
    color: '#f44336', // Rojo para error
    marginBottom: '10px',
  },
  message: {
    fontSize: '16px',
    color: '#333',
    margin: '10px 0 20px', // Margen superior e inferior
  },
  button: {
    padding: '10px 20px',
    backgroundColor: COLORS.primary.main,
    color: COLORS.primary.fondoItem,
    border: 'none',
    borderRadius: '50px',
    cursor: 'pointer',
    fontSize: '16px',
    minWidth: '120px',
    '&:hover': {
      backgroundColor: COLORS.primary.background,
      color: COLORS.primary.main,
    },
  },
  buttonCancel: {
    padding: '10px 20px',
    backgroundColor: "white",//COLORS.primary.background,
    color: COLORS.primary.main, 
    border: `2px solid ${COLORS.primary.main}`,
    borderRadius: '50px',
    cursor: 'pointer',
    fontSize: '16px',
    transition: 'all 0.3s ease',
    minWidth: '120px',
    '&:hover': {
      backgroundColor: COLORS.primary.background,
      color: COLORS.primary.main,
      borderColor: 'darkred',
    },
  }
});
